define(function (require) {
  var $ = require("jquery");
  var userProfile = require("site/mobile/user-profile");
  var modalWindow = require("site/mobile/modal-window");
  var login = require("./log-in-page-login");
  var loginEvents = require("site/common/analytics/login-events");
  var cms = require("common/page-config").cms;
  const cfTurnstile = require("site/common/cf-turnstile");

  require("jquery-validate");

  const checkoutLoginEvents = loginEvents.trackEventLogInPage();

  var logInPageValidation = {
    forgottenPassword (validate) {
      var options = {
        rules: {
          "psswd-email": {
            required: true
          }
        },

        messages: {
          "psswd-email": {
            required: cms.loginValidation["email-required"]
          }
        },

        submitHandler () {
          modalWindow.show();
          userProfile.resetPassword($("#psswd-email").val(), function (forgottenStatus) {
            if (forgottenStatus === "OK") {
              modalWindow.hide();
              $("#success-message").popup("open");
            } else {
              modalWindow.hide();
              $("#forgot-error-message").popup("open");
            }
          });
        }
      };

      options = validate.options(options, "#validation-error-popup-forgot");
      $("#forgotten-password-form").validate(options);
      $("#forgotten-password-form input").on("blur", function () {
        $(this).valid();
      });
    },

    login (variant, pageName, validate) {
      var $loginForm = $(pageName).find(".login-form");
      var $loginEmailInput = $loginForm.find(".login-email");
      var $loginPassInput = $loginForm.find(".login-psswd");
      var options = {
        rules: {
          "login-email": {
            required: true,
            email: true
          },
          "login-psswd": {
            required: true
          }
        },
        invalidHandler () {
          checkoutLoginEvents.failure();
        },
        focusInvalid: false,

        messages: {
          "login-email": {
            required: cms.loginValidation["email-required"]
          },
          "login-psswd": {
            required: cms.loginValidation["password-required"]
          }
        },

        submitHandler (form, evt) {
          evt.preventDefault();
          if (!["hasToken", "uninitialised"].includes(cfTurnstile.getState())) {
            return;
          }

          var email = $loginEmailInput.val();
          var password = $loginPassInput.val();

          login({
            $loginForm,
            validator: validate,
            userEmail: email,
            userPassword: password,
            pageVariant: variant
          });
        }
      };

      var $page = $.mobile.pageContainer.pagecontainer("getActivePage");
      var errorPopupId = $page.find(".validation-error-popup-login").attr("id");

      options = validate.options(options, "#" + errorPopupId);
      $loginForm.validate(options);
      $loginForm.find("input").on("blur", function () {
        $(this).valid();
      });
    },

    attachValidationRules (variant, pageName, validate) {
      logInPageValidation.login(variant, pageName, validate);
      logInPageValidation.forgottenPassword(validate);
    }
  };

  return logInPageValidation.attachValidationRules;
});
